const usLangSale = {
  'sale.helmet': 'Sell',
  'sale.code': 'Code',
  'sale.gift': 'Present',
  'sale.cash': 'Cash',
  'sale.number': 'Value',
  'sale.percent': 'Exchange',
  'sale.maximum': 'Minimize',
  'sale.description': 'Describe',
  'sale.name': 'Name',
  'sale.btn-unselect-discount': 'Uncheck the discount code',
  'sale.discount-placeholder': 'Select the discount code',
  'sale.discount-empty-title': 'No discount/gift code is currently available.',
  'sale.create-order-success': 'Create successful orders!',
  'sale.create-order-failure': 'Create unsuccessful orders! Please try again later.',
  'sale.create-order-loading': 'Conducting order ...',
  'sale.header.search-input.placeholder-1': 'Find goods',
  'sale.header.search-input.placeholder-2': 'Find sample prescriptions',
  'sale.header.order-tab-name': 'Invoice',
  'sale.header.btn-delete-order-tab': 'Delete',
  'sale.header.btn-add-order-tab': 'Add',
  'sale.header.link.admin': 'Management page',
  'sale.header.link.logout': 'Log out',
  'sale.header.btn-add-product': 'Add new goods',
  'sale.footer.tab.sell-quickly': 'Fast sale',
  'sale.footer.tab.sell-casual': 'Sell',
  'sale.footer.btn-tutorial': 'User manual',
  'sale.footer.btn-letter': 'Feedback',
  'sale.item.more-action.note': 'Note',
  'sale.item.more-action.detail': 'Product detail',
  'sale.item.note.placeholder': 'Note...',
  'sale.container.footer.note-placeholder': '✎ Note of order',
  'sale.container.footer.total-price-tmp': 'Total money',
  'sale.sell-casual-tab.btn-filter': 'Product filter',
  'sale.sell-casual-tab.btn-view-mode-list': 'List mode',
  'sale.sell-casual-tab.btn-view-mode-thumbnail': 'Image mode',
  'sale.sell-casual-tab.btn-payment': 'Pay',
  'sale.sell-casual-tab.title-1': 'Total money',
  'sale.sell-casual-tab.title-2': 'Discount',
  'sale.sell-casual-tab.title-3': 'Guests need to pay',
  'sale.sell-casual-tab.title-4': 'Payment guests',
  'sale.sell-casual-tab.title-5': 'Excess payment of passengers',
  'sale.sell-casual-tab.payment-type.cash': 'Cash',
  'sale.sell-casual-tab.payment-type.bank': 'Transfer',
  'sale.sell-casual-tab.payment-type.card': 'Card',
  'sale.sell-casual-tab.add-account-bank-title': 'Add bank account',
  'sale.loading-customer-title': 'Searching...',
  'sale.search-customer-placeholder': 'Find customers',
  'sale.btn-unselect-user': 'Uncheck customers',
  'sale.btn-add-user': 'Add new customers',
  'sale.select-discount': 'Select the discount code',
  'sale.modal.customer.create.title': 'Add new customers',
  'sale.modal.customer.detail.title': 'Customer information',
  'sale.modal.customer.update.title': 'Update customer information',
  'sale.modal.customer.error-length-max': 'Maximum $x character!',
  'sale.modal.customer.name.col': 'Customer name',
  'sale.modal.customer.name.placeholder': 'Nguyen Van A',
  'sale.modal.customer.name.error-required': 'Please enter the customer name!',
  'sale.modal.customer.phone.col': 'Phone',
  'sale.modal.customer.phone.placeholder': '08xxxxxxxx',
  'sale.modal.customer.phone.error-required': 'Please enter the phone number!',
  'sale.modal.customer.phone.error-invalid': 'Invalid phone number!',
  'sale.modal.customer.phone.is-exist': 'The phone number has been registered!',
  'sale.modal.customer.email.col': 'Email',
  'sale.modal.customer.email.placeholder': 'email@example.com',
  'sale.modal.customer.email.error-invalid': 'Invalid email!',
  'sale.modal.customer.address.col': 'Address',
  'sale.modal.customer.birthday.col': 'Date of birth',
  'sale.modal.note.create-customer.success': 'Add new successful customers!',
  'sale.modal.note.create-customer.failure': 'More new customers are not successful! Please try again later.',
  'sale.modal.note.update-customer.success': 'Update customer information successfully!',
  'sale.modal.note.update-customer.failure': 'Update customer failure successfully! Please try again later.',
  'sale.modal.btn-create': 'More',
  'sale.modal.btn-update': 'Update',
  'sale.title-add-customer': 'Add new customers',
  'sale.modal.note.confirm.create-customer.title': 'Confirm more customers',
  'sale.modal.note.confirm.create-customer.description': 'You definitely want to add customers <strong>$x</strong>?',
  'sale.modal.note.confirm.update-customer.title': 'Confirm customer information update',
  'sale.modal.note.confirm.update-customer.description': 'You definitely want to update customer information <strong>$x</strong>?',
  'sale.modal.failure.title': 'An error occurred!',
  'sale.modal.failure.description': 'Please come back later, or click the <strong>Refresh</strong> button to try again.',
  'sale.modal.failure.btn': 'Refresh',
  'sale.btn.bill': 'Selling drugs by applications',
  'sale.modal.bill.title': 'Drug information',
  'sale.modal.billCode.label': 'Prescription code',
  'sale.modal.billCode.error-required': 'Please enter the prescription code!',
  'sale.modal.doctor.label': 'Doctor prescribed',
  'sale.modal.hospital.label': 'Examination facility',
  'sale.modal.name.label': 'Patient name',
  'sale.modal.age.label': 'Year old',
  'sale.modal.gender.label': 'Sex',
  'sale.modal.gender.male.label': 'nam',
  'sale.modal.gender.female.label': 'Female',
  'sale.modal.weight.label': 'Weight',
  'sale.modal.id_card.label': 'CCCD',
  'sale.modal.id_bhyt.label': 'Card BHYT',
  'sale.modal.address.label': 'Address',
  'sale.modal.phone.label': 'Contact phone',
  'sale.modal.note.label': 'Diagnostic',
  'sale.modal.bill.btn.back': 'Skip',
  'sale.modal.bill.btn.save': 'Finished',
  'sale.failure.title.missing-customer': 'Please choose customers for orders!',
  'sale.failure.description.missing-customer': 'For visitors, choose <strong>Guests</strong>.',
  'sale.failure.description.missing-bill-code': 'Please enter <strong>Prescription code</strong> with the application <strong>Selling drugs under the prescription</strong>.',
  'sale.dropdown.bill-code': 'Prescription code',
  'sale.dropdown.order-code': 'Code orders',
  'sale.dropdown.username-name': 'Client',
  'sale.dropdown.username-phone': 'Phone number',
  'sale.empty-bill-info': 'There has been no results for your search.',
  'sale.staff.btn-remove': 'Unselect',
  'sale.staff-empty-title': 'There is currently no staff on the same shift as you.',
  'sale.staff-loading-title': 'Loading the list of employees in the shift...',
  'sale.dropdown.item.name': 'Name',
  'sale.dropdown.item.phone': 'Phone',
  'sale.dropdown.item.email': 'Email',
  'sale.cart-item-total': 'Total',
  'sale.modal.detail-product': 'The detail information of product',
  'sale.modal.detail-product.code.label': 'Code',
  'sale.modal.detail-product.barcode.label': 'Barcode',
  'sale.modal.detail-product.name.label': 'Name',
  'sale.modal.detail-product.image.label': 'Image',
  'sale.modal.detail-product.source.label': 'Source',
  'sale.modal.detail-product.unit.label': 'Unit',
  'sale.modal.detail-product.desc.label': 'Description',
  'sale.modal.detail-product.price.label': 'Price',
  'sale.screen-filter-product.title': 'Filter product',
  'sale.screen-filter-product.sub-title-category': 'Product Categories',
  'sale.screen-filter-product.all': 'All',
  'sale.screen-filter-product.btn-clear': 'Cancel',
  'sale.screen-filter-product.btn-back': 'Back',
  'sale.screen-filter-product.btn-accept': 'Filter',
  'sale.inventory': 'Quantity',
  'sale.inventory-empty': 'Empty',
  'sale.quantity': 'Quantity',
  'sale.modal.work-places.title': 'Choose work place',
  'sale.modal.error-msg-work-place-require': 'Work place is required!',
  'sale.modal.work-places.btn-submit': 'Continue',
  'sale.barcode-scanner': 'Barcode scanner',
  'sale.render-qr-code.title': 'Banking information',
};

export default usLangSale;
